module.exports = __webpack_public_path__ + "img/img2.2542bcf4.png";